<template>
  <div class="artwork-history-empty-state">
    <UseSvg class="artwork-history-empty-state__icon" :icon="icon" />
    <template v-if="isLibrarySection">
      <span v-if="isLoading">
        Loading... <br />
        &nbsp;
      </span>
      <span v-else>
        Your saved designs will show here. <br />
        Pick from millions of premium images from <a href="/designs/">Jiffy Designs</a>
      </span>
    </template>
    <template v-else>
      <span> {{ emptyStateText }} </span>
    </template>
  </div>
</template>

<script>
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

export default {
  name: "ArtworkHistoryModalEmptyState",
  components: { UseSvg },
  props: {
    sectionType: {
      required: true,
      type: String
    },
    isLoading: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    emptyStateText() {
      return this.isLoading ? "Loading..." : "Previous transfers purchases will show here.";
    },
    isLibrarySection() {
      return this.sectionType === "library";
    },
    icon() {
      return this.isLibrarySection ? "empty-image" : "rebrand-carts";
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.artwork-history-empty-state {
  font-family: inherit;
  font-weight: 600;
  color: $crafterpay-gray-modern-700;
  padding: 20px;
  font-size: 16px;
  line-height: 22px;
  height: 300px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-height: 768px;

  @include with-tablet {
    height: calc(100vh - 430px);
  }

  &__icon {
    width: 80px;
    height: 80px;
    color: $crafterpay-gray-modern-300;
  }
}
</style>
